module.exports = {
    SecertKey: 'd3b2bb5c-83e4-4441-9769-ce7f194d7513',
    RoutUser: '/user/home',
}


// WEBPACK FOOTER //
// ./src/config/index.js